// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 909 ? "notifications" : chunkId) + "." + {"198":"aa0b9c75","703":"dfe7c3ea","721":"d54d5f27","787":"dab42702","909":"0898ac96"}[chunkId] + ".chunk.js";
};